import React from 'react';
import { useRouteError, isRouteErrorResponse, useNavigate } from 'react-router-dom';

/**
 * Route-level error boundary element.
 *
 * Rendered by react-router when a matched route (or its loader/action)
 * throws. Presents a minimal error surface and offers a recovery path.
 *
 * Kept intentionally lightweight so it does not pull in redux/dialog UI —
 * those hooks may not be safe to call from an errored subtree.
 */
const RouteError = () => {
    const error = useRouteError();
    const navigate = useNavigate();

    const status = isRouteErrorResponse(error) ? error.status : 'Error';
    const statusText = isRouteErrorResponse(error) ? error.statusText : (error?.message ?? 'Something went wrong');

    return (
        <div className="routeErrorScreen" role="alert" style={{ padding: '2rem', textAlign: 'center' }}>
            <h1 style={{ marginBottom: '0.5rem' }}>{status}</h1>
            <p style={{ marginBottom: '1.5rem' }}>{statusText}</p>
            <button
                type="button"
                className="btn"
                onClick={() => navigate('/', { replace: true })}
            >
                Back to home
            </button>
        </div>
    );
};

export default RouteError;
